(function () {
    'use strict';

    angular
        .module('surveyControllers')
        .controller('SurveyRespondentController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'surveyService', 'survey'];

    function Controller($scope, $state, topBarService, surveyService, survey) {

        if ($state.is('survey.forRespondent')) {

            if (survey.Availability.IsReadyForRespondent) {
                $state.go('survey.forRespondent.welcome', {}, { location: 'replace' });

            } else if (survey.Availability.IsComplete) {
                $state.go('survey.forRespondent.completed', {}, { location: 'replace' });
            }
        }

        if (!$state.is('survey.forRespondent.notAvailable') && survey.Availability.IsNotAvailable) {

            $state.go('survey.forRespondent.notAvailable', {}, { location: 'replace' });
        }

        topBarService.setTitleAndIcon(survey.Campaign.TitleEN, 'fa fa-bullhorn');

        $scope.survey = survey;

        $scope.goToNextSurveyPageToProcess = function () {
            surveyService
                .getNextPageToProcess(survey.Campaign.SlugObject)
                .then(function (nextpageToProcess) {
                    $state.go('survey.forRespondent.page', { PageNumber: nextpageToProcess.PageNumber });
                });
        };
    }
})();